import { createStore as reduxCreateStore, combineReducers } from 'redux';

import * as navigation from './ducks/navigation';

const createStore = () =>
  reduxCreateStore(combineReducers({ navigation: navigation.reducer }));
export default createStore;



// WEBPACK FOOTER //
// ./src/state/createStore.js